module.exports = __webpack_public_path__ + "static/web-2-ab01065169a1483edc9c8453d8b90f3d.mp4";